import React from "react";

const IconPlugAndPlay = ({ size = "30" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.0219 6.75424C11.0219 9.52176 8.77848 11.7652 6.01095 11.7652C3.24343 11.7652 1 9.52176 1 6.75424C1 3.98671 3.24343 1.74329 6.01095 1.74329C8.77848 1.74329 11.0219 3.98671 11.0219 6.75424Z"
        stroke="#2A7DE1"
        stroke-width="1.55972"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.01627 6.66123L5.53074 8.2775L8.42771 5.40063"
        stroke="#2A7DE1"
        stroke-width="1.55972"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.5077 24.0945L14.7436 21.8586L8.9044 16.0206L6.66851 18.2553C5.18923 19.7345 5.18923 22.1326 6.66851 23.6118L7.15113 24.0945C8.63041 25.5737 11.0284 25.5737 12.5077 24.0945Z"
        stroke="#2A7DE1"
        stroke-width="1.55972"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.5589 17.2731L12.0218 15.8102"
        stroke="#2A7DE1"
        stroke-width="1.55972"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.4903 20.2045L14.9532 18.7416"
        stroke="#2A7DE1"
        stroke-width="1.55972"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.4815 6.91622L15.2456 9.15211L21.0848 14.9901L23.3207 12.7554C24.7999 11.2761 24.7999 8.87812 23.3207 7.39884L22.838 6.91622C21.3588 5.43694 18.9607 5.43694 17.4815 6.91622Z"
        stroke="#2A7DE1"
        stroke-width="1.63387"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.81167 24.2454L1.00012 29.47"
        stroke="#2A7DE1"
        stroke-width="1.63387"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M29 1.53003L23.1884 6.75464"
        stroke="#2A7DE1"
        stroke-width="1.63387"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default IconPlugAndPlay;
